import React, { useState } from 'react';
import '../constants/ColorCodes.css';
import { Checkbox, InputGroup } from '@blueprintjs/core';
import ClassArea from './ClassArea';
import CollapsibleSection from '../components/CollapsibleSection/CollapsibleSection';
import FeatureCard from '../components/FeatureCard/FeatureCard';
import TeachRTooltip from "../components/Tooltip/TeachRTooltip"
import { Divider } from '@blueprintjs/core';
{/* Top */ }
import ThemeSelectionPanel from '../features/SessionSettings/ThemeSelectionPanel';
import ScenarioSelectionPanel from '../features/SessionSettings/ScenarioSelectionPanel';

{/* Left */ }
import SchoolGong from '../features/schoolGong/SchoolGong';
import Weather from '../features/SessionSettings/Weather';
import VolumeSlider from '../features/SessionSettings/VolumeSlider';
import PresentationControlPanel from '../features/SessionSettings/PresentationControlPanel';

{/* Bottom */ }
import BehaviourManagement from '../features/behaviourControls/behaviourGroups/BehaviourManagement/'
import ImpulseControls from '../features/behaviourControls/behaviourGroups/ImpulseControls'
{/* Right */ }
import DataCollectionControlPanel from '../features/SessionSettings/DataCollectionControlPanel';


/**
 * This component serves as a layout for the teach - r session page with a menu bar,
 * collapsible sections, and the class area. The layout consists of:
 * 
 * - Top Section: Settings before a session
 * - Left Section: Settings during a session
 * - Right Section: realtime informations
 * - Bottom Section: session control
 * - ClassArea: see vSuS / select them
 *
 * The layout is designed to fill the viewport height and adapt to different screen sizes. 
 * The`CollapsibleSection` components can be collapsed or expanded to show / hide their content.
 *
 * @returns { JSX.Element } The rendered `TeachRPage` component, which includes a menu bar, collapsible sections, 
 * and a class area arranged in a responsive layout.
 */
const TeachRPage = ({ onNext }) => {
    // State management for checkboxes DEBUG, move into own component!!! DEBUG
    const [teacherMovement, setTeacherMovement] = useState(false);
    const [fov, setFov] = useState(false);
    const [speechData, setSpeechData] = useState(false);
    const [heartrate, setHeartrate] = useState(false);
    const [filename, setFilename] = useState('');

    // Event handler for checkbox changes DEBUG
    const handleEnabledChange = (event) => {
        const { name, checked } = event.target;
        switch (name) {
            case 'teacherMovement':
                setTeacherMovement(checked);
                break;
            case 'fov':
                setFov(checked);
                break;
            case 'speechData':
                setSpeechData(checked);
                break;
            case 'heartrate':
                setHeartrate(checked);
                break;
            default:
                break;
        }
    };

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column'}}>
            <div style={{ backgroundColor: 'var(--gray_2)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {/* DEBUG FUNCTIONALITY, REMOVE FOR FINAL VERSION */}
                <button onClick={onNext}>Reflect on session</button>
            </div>

            {/* Main Section */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
                {/* Left Section */}
                <CollapsibleSection position="left" title="Circumstances" size={410} collapsible={true}>
                    <FeatureCard title='Weather' collapsible={true} ><Weather /></FeatureCard>
                    <FeatureCard title='School Gong' collapsible={true} ><SchoolGong/></FeatureCard>
                    <FeatureCard title='Presentation' collapsible={true} ><PresentationControlPanel/></FeatureCard>
                    <FeatureCard title='Volume' collapsible={true} ><VolumeSlider/></FeatureCard>
                </CollapsibleSection>
                <Divider/>
                {/* Classroom in the center */}
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                    {/* ClassArea */}
                    <div style={{ flex: 1, minHeight:'500px' }}>
                        <ClassArea />
                    </div>

                    {/* Bottom Section */}
                    <div style={{ flexShrink: 0 }}>
                        <CollapsibleSection position="bottom" title="Circumstances" size={320} collapsible={true}>
                            <FeatureCard title='Teaching subject' collapsible={true} ><ThemeSelectionPanel /></FeatureCard>
                            <FeatureCard title='Scenario' collapsible={true} ><ScenarioSelectionPanel /></FeatureCard>
                            <FeatureCard title='Actions for virtual Students' collapsible={true} ><BehaviourManagement /></FeatureCard>
                            <FeatureCard title='Evaluation of Teacher Actions' collapsible={true} ><ImpulseControls/></FeatureCard>
                            {/*<FeatureCard title='Bottom 3' collapsible={true} >Insert idea for bottom content here!</FeatureCard>*/}
                        </CollapsibleSection>
                    </div>
                </div>

                {/* Right Section */}
                <Divider />
                <CollapsibleSection position="right" title="Feedback" size={410} collapsible={true}>
                    <FeatureCard title='Data collection' collapsible={true} >
                        <DataCollectionControlPanel/>
                    </FeatureCard>
                    <FeatureCard title='Heartrate' collapsible={true} >View Heartrate</FeatureCard>
                    <FeatureCard title='Speech' collapsible={true} >
                        <p>View Speechrate</p>
                        <p>View fillerwords count</p>
                        <p>View other statistics ...</p>
                    </FeatureCard>
                    <FeatureCard title='just-in-time settings' collapsible={true} >Set which just-in-time information is displayed to the Immersanti e.g. heartrate, speechrate, ... [4CID].</FeatureCard>
                    <FeatureCard title='Scenario Events' collapsible={true} >Show scenario events in real time</FeatureCard>
                    {/*<FeatureCard title='Heatmaps' collapsible={true} >enable/disable different heatmaps like Teachers Position, FOV, ...</FeatureCard>*/}
                    {/*<FeatureCard title='Right X' collapsible={true} >Insert idea for top content here!</FeatureCard>*/}
                </CollapsibleSection>
            </div>
        </div>
    );
};

export default TeachRPage;